/* eslint-disable import/no-anonymous-default-export */
import { Button, Col, Form, Popconfirm, Row, Space, message, ProTableOt } from "./../../../components/ui/ot";
import { useRWDFunction } from '../controller/RWDFunctionController'
import RWDFunctionForm from "../component/RWDFunctionForm";
import { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import CarouselAvatar from "../component/CarouselAvatar";

const setParamsFilter = (obj) => {
    //拿掉值為空或是null 的東西
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
export default () => {
    const columns = [
        {
            title: '項次',
            dataIndex: 'key',
            valueType: 'indexBorder',
            width: 48,
            disabled: true
        },
        {
            title: '連結排序',
            dataIndex: 'index',
            key: 'index',
        },
        {
            title: '標題',
            dataIndex: 'rwd_function_name',
            key: 'rwd_function_name',
        },
        {
            title: '圖示',
            key: "file_data",
            dataIndex: 'file_data',
            ellipsis: true,
            sorter: false,
            render: (text, record, index) => (<>
                <CarouselAvatar fileData={record.file_data} />
            </>),
        },
        {
            title: '連結',
            key: "rwd_function_url",
            dataIndex: 'rwd_function_url',
            ellipsis: true,
            copyable: true
        },
    ];
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.rwd_function_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.rwd_function_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                select_temp.push(record.rwd_function_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.rwd_function_id)
                selectRow = selectRow.filter(row => row.rwd_function_id !== record.rwd_function_id)
            }
            setSelectedRowKeys(pre => select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };

    const [form] = Form.useForm();

    const actionRef = useRef();

    const [extra_columns, set_extra_columns] = useState([]);
    const [pageSize, setPageSize] = useState(20)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [axiosMode, setAxiosMode] = useState("get")
    const [roleData, setRoleData] = useState([])

    const onCleanSelected = () => {
        setSelectedRowKeys([])
        setSelectedRowsInfo([])
    }
    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleEditRow = (record) => {
        setAxiosMode("patch")
        setModalOpen(true)
        form.resetFields()
        form.setFieldsValue({
            ...record
        })
    }
    const handleDeleteRow = (id) => {

        let data = []
        if (id) {
            data = [{
                rwd_function_id: id
            }]
        }
        else {
            data = selectedRowsInfo.map((val) => {
                return {
                    rwd_function_id: val?.rwd_function_id
                }
            })
        }
        if (data.length > 0) {
            setAxiosMode("delete")
            deletehRWDFunctionData(data)
            selectedRowsInfo([])
            selectedRowKeys([])
        }
        else {
            message.info("請選擇項目")
        }
    }

    const onFormFinish = (values) => {
        if (axiosMode === "post") {
            postRWDFunctionData([values])
        }
        else if (axiosMode === "patch") {
            patchRWDFunctionData([values])
        }
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();

            }
            setModalLoading(false)
            setModalOpen(false)
            setSelectedRowKeys([])
            setSelectedRowsInfo([])
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                actionRef.current.reloadAndRest();
                message.error("新增失敗")
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                actionRef.current.reloadAndRest();

            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }

    const {
        getRWDFunctionData,
        postRWDFunctionData,
        patchRWDFunctionData,
        deletehRWDFunctionData,
    } = useRWDFunction({
        onFinish,
        onBefore,
    })

    const {
        check,
        setCheck,
        checkAll,
        custom_filter_key,
    } = useTableColumnsCheck(columns)

    useEffect(() => {
        checkAll()
    }, [])

    return <Row>
        <Col span={24}>
            <ProTableOt
                actionRef={actionRef}
                headerTitle={<></>}
                columns={columns}
                check={check}
                setCheck={setCheck}
                rowKey={'rwd_function_id'}
                selections={{
                    // onChange: (index_, data_) => set_data(data_)
                }}
                toolBarRender={() => []}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    setAxiosMode("get")
                    let newParams = {
                    };

                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        size: params.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20)
                    return getRWDFunctionData(newParams)
                }}
                pageSize={pageSize}
                rowSelection={{
                    type: 'checkbox',
                    selectedRowKeys: selectedRowKeys,
                    setSelectedRowKeys,
                    selectedRowsInfo,
                    setSelectedRowsInfo,
                    ...rowSelection,
                }}
                tableAlertOptionRender={() => {
                    return (
                        <Space size={16}>
                            {/* <Typography.Link>匯出資料</Typography.Link> */}
                        </Space>
                    )
                }}
                tableAlertRender={({
                    selectedRowKeys,
                    selectedRows,
                    // onCleanSelected,
                }) => {
                    return (
                        <Space size={24}>
                            <span>
                                已選擇 {selectedRowKeys.length} 項
                                <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                                    取消選擇
                                </a>
                            </span>
                        </Space>
                    );
                }}
                scroll={{
                    x: "max-content"
                }}

                PropsPatchForm={<RWDFunctionForm />}
                propsUseData={() => {
                    return {
                        postData: (value) => {
                            let datas = []
                            value.forEach(values => {
                                datas.push({
                                    ...values,
                                })
                            })
                            return postRWDFunctionData(datas)
                        },
                        patchData: (value,...e) => {
                            let datas = []
                            value.forEach(values => {
                                datas.push({
                                    ...values,
                                })
                            });
                            console.log({
                                
                            })
                            return patchRWDFunctionData(datas)
                        },
                        deleteData: deletehRWDFunctionData
                    }
                }}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                propsPatchProcess={(record) => {
                    let editData = record
                    return {
                        ...editData,
                    }
                }}
                propsPatch
                propsPost
                propsDelete
                formMode={true}
            />
        </Col>
    </Row>
}

// const useTableColumnsCheck = (columns) => {
//     const [check, setCheck] = useState([])
//     const checkAll = () => {
//         setCheck((pre) => {
//             return columns
//                 .filter((element) => !element.disabled)
//                 .map((val) => val.key);
//         });
//     }
//     return {
//         check,
//         custom_filter_key: JSON.stringify(check)
//             .replace("[", "")
//             .replace("]", "")
//             .replaceAll('"', ""),
//         setCheck,
//         checkAll,
//     }
// }
const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        if (sorter) {
            let newOrders = Object.keys(sorter).map((key, index) => {
                if (sorter[key] === "descend") {
                    return JSON.stringify({
                        column: key,
                        type: 'DESC'
                    })
                }
                else {
                    return JSON.stringify({
                        column: key,
                        type: 'ASC'
                    })
                }

            })
            return newOrders
        }
        else {
            return []
        }
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
}